import { Injectable } from '@angular/core';
import { AppConfig } from '../models/app-config';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private static appConfig: AppConfig;

  constructor() {}

  loadAppConfig() {
    const promise = new Promise<void>((resolve, reject) => {
      fetch('/app-config.json')
        .then((response) => response.json())
        .then(
          function (c) {
            AppConfigService.appConfig = {
              oidcAuthority: c.oidcAuthority,
              oidcClientId: c.oidcClientId,
              oidcRedirectUri: c.oidcRedirectUri,
              oidcPostLogoutRedirectUri: c.oidcPostLogoutRedirectUri,
              oidcScopes: c.oidcScopes,
              oidcSilentRedirectUri: c.oidcSilentRedirectUri,
              apiRoot: c.apiRoot,
              version: c.version,
              applicationInsightsKey: c.applicationInsightsKey
            };

            resolve();
          },
          function () {
            reject();
          }
        );
    });

    return promise;
  }

  getConfig() {
    if (!AppConfigService.appConfig) {
      const ac: AppConfig = {
        oidcAuthority: '',
        oidcClientId: '',
        oidcRedirectUri: '',
        oidcPostLogoutRedirectUri: '',
        oidcScopes: '',
        oidcSilentRedirectUri: '',
        apiRoot: '',
        version: '',
        applicationInsightsKey: ''
      };

      return ac;
    }

    return AppConfigService.appConfig;
  }
}
